<template>
  <b-modal
    id="reservation-details-modal"
    v-model="visible"
    centered
    hide-footer
    title="Reservation details"
    modal-class="ds-modal"
  >
    <!-- Same summary the cancel modal shows, from the same helper, so the two can't
         describe one booking differently. -->
    <dl
      v-if="facts.length"
      class="ds-modal-facts"
    >
      <div
        v-for="fact in facts"
        :key="fact.label"
      >
        <dt>{{ fact.label }}</dt>
        <dd>{{ fact.value }}</dd>
      </div>
    </dl>

    <p
      v-if="!facts.length"
      class="dd-empty"
    >
      We don't have any detail for this reservation yet.
    </p>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import reservationFacts from '@/_helpers/reservation'

export default {
  name: 'DateDetails',
  components: {
    BModal,
  },
  props: {
    show: Boolean,
    date: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
  computed: {
    facts() {
      return reservationFacts(this.date)
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
    visible() {
      this.$emit('update:show', this.visible)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/design-system/mixins';

.dd-empty {
  @include ds-subtitle;
}
</style>
